var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircledArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    transform: "rotate(90 19.5 0.5)",
    stroke: "#243342"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3551 11.4148L12.4751 9.29485C12.5698 9.20097 12.623 9.07317 12.623 8.93985C12.623 8.80653 12.5698 8.67873 12.4751 8.58485C12.2801 8.39099 11.9652 8.39099 11.7701 8.58485L10.0001 10.3548L8.23015 8.58485C8.03513 8.39099 7.72017 8.39099 7.52515 8.58485C7.43155 8.67921 7.37938 8.80695 7.38015 8.93985C7.37938 9.07275 7.43155 9.20049 7.52515 9.29485L9.64515 11.4148C9.73903 11.5095 9.86683 11.5627 10.0001 11.5627C10.1335 11.5627 10.2613 11.5095 10.3551 11.4148Z",
    fill: "#243342"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircledArrowDown);
export default __webpack_public_path__ + "static/media/circled-arrow-down.5a1aab180f72a85dd790e818b06dc294.svg";
export { ForwardRef as ReactComponent };